import { render } from "./ButtonDomRemove.vue?vue&type=template&id=1249b61c"
import script from "./ButtonDomRemove.vue?vue&type=script&lang=js"
export * from "./ButtonDomRemove.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__